import React, { useEffect } from "react";
import Typewriter from "typewriter-effect";
import image from "../../images/my-bg1.png";
import "./Banner.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Banner = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
    });
  }, []);
  return (
    <div style={{ height: "100vh", background: "#2B3443" }}>
      <div className="container">
        <div
          className="d-flex flex-column flex-lg-row justify-content-between align-items-center"
          style={{ height: "100vh" }}
        >
          <div
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            className="pt-2"
          >
            <h5 className="fw-bold text-success">
              <Typewriter
                options={{
                  strings: [
                    "React Developer",
                    "Frontend Developer",
                    "Mern Stack Developer",
                    "Web Developer",
                  ],
                  autoStart: true,
                  loop: true,
                }}
              />
            </h5>
            <h1 className="text-success display-2 fw-bold">Motiur Rahman</h1>
            <p className="text-white lh-lg w-75 py-2">
              Hi, I am Motiur Rahman. I am a react Developer. I am 100% sincere,
              serious, hard-working, dedicated, committed, and honest.
            </p>
            <a
              href="https://drive.google.com/file/d/1CHnlHdACi_H5GGJXlYlzwOcXa84DiX3Z/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
              className="resume"
              style={{ textDecoration: "none" }}
            >
              <i class="fas fa-download"></i> Download Resume
            </a>
          </div>
          <div>
            <div className="banner-img">
              <img
                data-aos="fade-left"
                src={image}
                width="500"
                className="img-fluid"
                alt="Profile Pic"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
